module.exports = __webpack_public_path__ + "staticcomp/img/share.bad319f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/2/share.jpg
// module id = yTTk
// module chunks = 39